import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestChangeResellerLevel } from "./changeResellerLevel.request";

const useChangeResellerLevel = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestChangeResellerLevel,
    ...options
  });
};

export default useChangeResellerLevel;
